import { Box, Grid, Typography } from "@mui/material";
import { FileField, FileInput, FunctionField, Labeled, useNotify } from "react-admin";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import { getFile } from "server/components/DownloadFile";
import { customFile } from "features/customFile";

const CurriculumPdfDocument = ({ started, setPdfDocumentId }) => {
  const notify = useNotify();

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={6}
        md={4}
      >
        <FileInput
          placeholder={
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
              <AddIcon />
              {"Добавете файл в pdf формат"}
            </Box>
          }
          label="Pdf документ"
          source="pdfDocument"
          accept={{ "application/pdf": [".pdf"] }}
          readOnly={!started}
          onChange={e => {
            if (e) {
              customFile(
                "document/dynamic-documents",
                { File: e, SubCategoryId: 9, name: "DocumentName" },
                "POST",
                null,
                true,
              ).then(response => {
                setPdfDocumentId(response.data);
              });
            }
          }}
        >
          <FileField
            source="src"
            title="title"
          />
        </FileInput>
      </Grid>

      <Grid
        item
        md={6}
        xs={3}
      >
        <Labeled label="Свали документ">
          <FunctionField
            render={curriculum =>
              curriculum.pdfDocumentId ? (
                <Box
                  sx={{ display: "flex", alignItems: "flex-end", cursor: "pointer" }}
                  onClick={() => getFile(curriculum.pdfDocumentId, notify ? notify : "")}
                >
                  <DownloadIcon color="primary" />
                  <Typography
                    color={"primary"}
                    sx={{
                      textDecoration: "underline",
                      fontSize: "14px",
                      paddingTop: "5%",
                      paddingLeft: "14px",
                    }}
                    onClick={() => getFile(curriculum.pdfDocumentId, notify ? notify : "")}
                  >
                    {`Учебен план-${curriculum.validFrom}-${curriculum.name}.pdf`}
                  </Typography>
                </Box>
              ) : (
                "-"
              )
            }
          />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default CurriculumPdfDocument;
